import axios from 'axios';
import { getToken } from '../../../utils/authToken';
import { jwtDecode } from 'jwt-decode';
import { getCourseBaseUrl } from './getCourseBaseUrl';
import {
  getCourseStudentToken,
  setCourseStudentToken,
  clearCourseStudentToken,
} from '../utils/courseTokenStorage';

export { getCourseStudentToken, setCourseStudentToken, clearCourseStudentToken };

function getAdminToken() {
  let token = localStorage.getItem('admin_token');
  if (!token) {
    const cookieToken = getToken();
    if (cookieToken) {
      try {
        const decoded = jwtDecode(cookieToken);
        if (decoded.role === 'admin') {
          token = cookieToken;
        }
      } catch (e) {
        // ignore
      }
    }
  }
  return token || null;
}

const courseAxios = axios.create({
  baseURL: getCourseBaseUrl(),
  timeout: 60000,
});

courseAxios.interceptors.request.use(
  (config) => {
    const authMode = config.authMode || 'course';

    if (authMode === 'none' || authMode === 'public') {
      delete config.headers.Authorization;
      return config;
    }

    if (authMode === 'admin') {
      const adminToken = getAdminToken();
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      } else {
        delete config.headers.Authorization;
      }
      return config;
    }

    const courseToken = getCourseStudentToken();
    if (courseToken) {
      config.headers.Authorization = `Bearer ${courseToken}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

courseAxios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default courseAxios;
